import { getTournamentRules } from '@core/tournaments/tournamentRulesContent'

// Pure render of static rules copy (no BE field exists for this — see
// tournamentRulesContent.js). No fake loading state, unlike defenderV2's
// 300ms setTimeout purely to justify a spinner.
const TournamentRulesTab = ({ type, timeFrom, timeTo }) => {
  const rules = getTournamentRules(type, { timeFrom, timeTo })

  if (!rules.length) {
    return (
      <div className="standard-normal-tournament-rules-empty-container">
        No Rules Found for this Tournament
      </div>
    )
  }

  return (
    <div className="standard-normal-tournament-rules-outer-container">
      <div className="standard-normal-tournament-rules-title">Win Criteria</div>
      <ul className="standard-normal-tournament-rules-list no-scrollbar">
        {rules.map((rule, index) => (
          <li key={index} className="standard-normal-tournament-rules-item">
            {rule}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default TournamentRulesTab
